// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__gvXQ5","innerWrapper":"Navbar_innerWrapper__Q2OnD"};